import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "6",
  viewBox: "0 0 16 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.167 5.167a2.167 2.167 0 1 0 0-4.334 2.167 2.167 0 0 0 0 4.334ZM8 5.167A2.167 2.167 0 1 0 8 .833a2.167 2.167 0 0 0 0 4.334ZM13.833 5.167a2.167 2.167 0 1 0 0-4.334 2.167 2.167 0 0 0 0 4.334Z",
  fill: "#184DB4"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };